export const formatID = (projectId: number | string, prefix = ""): string => {
  return `${prefix}${String(projectId).padStart(6, "0")}`;
};
